import React, { FC } from 'react';
import { Spin } from 'antd';
import { FileTextOutlined, LoadingOutlined } from '@ant-design/icons';

interface ComplianceAiLoadingStateProps {
	title: string;
	description: string;
	// Name of the file being read, shown so the user can see which one is in flight.
	fileName?: string;
}

// Shown while the backend has a document with the model — extracting a checklist
// from a buyer's sample, or checking a supplier's document against one. There is
// no progress to report from a model call, so this is a plain indeterminate state.
export const ComplianceAiLoadingState: FC<ComplianceAiLoadingStateProps> = ({
	title,
	description,
	fileName,
}): React.ReactElement => (
	<div className="flex flex-col items-center gap-4 py-10 text-center">
		<Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin={true} />} />
		<div className="h5medium">{title}</div>
		<div className="bodyregular max-w-md text-character-secondary">{description}</div>
		{fileName ? (
			<div className="footnoteregular inline-flex items-center gap-2 text-character-secondary">
				<FileTextOutlined />
				<span>{fileName}</span>
			</div>
		) : null}
	</div>
);
